module.exports = __webpack_public_path__ + "img/Jira.5f15da9.svg";